"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTADO_INTEGRACAO_OMIE_LABEL = void 0;
exports.ESTADO_INTEGRACAO_OMIE_LABEL = {
    SOMENTE_LOCAL: 'Somente local',
    PENDENTE: 'Pendente',
    SINCRONIZADO: 'Sincronizado',
    FALHA_SINCRONIZACAO: 'Falha na sincronização',
    CONFLITO: 'Conflito a resolver',
};
//# sourceMappingURL=cadastros.js.map